(() => {
  function parseNumericAttribute(block, name, fallback) {
    const value = parseFloat(block.getAttribute(name));

    if (!Number.isFinite(value)) {
      return fallback;
    }

    return value;
  }

  function formatFreeShippingThreshold(amount) {
    if (!Number.isFinite(amount)) {
      return '';
    }

    return String(Math.round(amount));
  }

  if (!window.themeUpdateFreeShippingThresholdTokens) {
    window.themeUpdateFreeShippingThresholdTokens = function updateFreeShippingThresholdTokens() {
      document.querySelectorAll('[data-free-shipping-threshold-token][data-auto-convert-threshold="true"]').forEach((block) => {
        const currency = block.getAttribute('data-target-currency') || 'EUR';
        const symbol = block.getAttribute('data-target-currency-symbol') || currency;
        let amount = parseNumericAttribute(block, 'data-base-amount-eur', 0);
        const bufferPercent = parseNumericAttribute(block, 'data-conversion-buffer-percent', 0);
        let roundingStep = parseNumericAttribute(block, 'data-conversion-rounding-step', 1);

        if (!amount) {
          return;
        }

        if (!Number.isFinite(roundingStep) || roundingStep <= 0) {
          roundingStep = 1;
        }

        if (currency !== 'EUR') {
          const currencyRate = window.Shopify && window.Shopify.currency ? parseFloat(window.Shopify.currency.rate) : 1;

          if (!Number.isFinite(currencyRate) || currencyRate <= 0) {
            return;
          }

          amount *= currencyRate;
          amount *= 1 + bufferPercent / 100;
          amount = Math.ceil(amount / roundingStep) * roundingStep;
        }

        block.querySelectorAll('[data-free-shipping-threshold-symbol]').forEach((element) => {
          element.textContent = symbol;
        });

        block.querySelectorAll('[data-free-shipping-threshold-amount]').forEach((element) => {
          element.textContent = formatFreeShippingThreshold(amount);
        });
      });
    };
  }

  if (!window.themeFreeShippingThresholdTokensInitialized) {
    window.themeFreeShippingThresholdTokensInitialized = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', window.themeUpdateFreeShippingThresholdTokens);
    }

    document.addEventListener('shopify:section:load', window.themeUpdateFreeShippingThresholdTokens);
  }

  window.themeUpdateFreeShippingThresholdTokens();
})();
